import actionButton from '../../genericTable/actionButtons/actionButton';

export class GenericTableEditButton {
  cod = 'editButton';
  eventType = 'edit';
  classImage = 'fas fa-pen';
  component = actionButton;
}
